export const getLastActiveLabel = (lastActivity: string | null) => {
  if (!lastActivity) return "-";

  const lastDate = new Date(lastActivity);
  const today = new Date();

  // Normalize both to midnight (remove time part)
  lastDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffInDays =
    (today.getTime() - lastDate.getTime()) / (1000 * 60 * 60 * 24);

  if (diffInDays === 0) return "Today";
  if (diffInDays === 1) return "1 day ago";
  if (diffInDays === 2) return "2 days ago";
  if (diffInDays === 3) return "3 days ago";

  return `${diffInDays} days ago`;
};
